import { useCallback } from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { productRouter, productUtils } from "@editor/trpc/product";

import { ReploError } from "schemas/errors";

interface ProductDeleteResponse {
  deleteProduct: (productId: string) => Promise<void>;
  isLoading: boolean;
}

class ProductDeleteError extends ReploError {}

export const useProductDelete = (): ProductDeleteResponse => {
  const projectId = useCurrentProjectId();

  const deleteProductMutation = productRouter.deleteReploProduct.useMutation({
    onSuccess: () => {
      void productUtils.list.invalidate();
    },
  });

  const deleteProduct = useCallback(
    async (productId: string) => {
      if (!projectId) {
        throw new ProductDeleteError({
          message: "Missing required project ID for product deletion",
          additionalData: {
            projectId,
            productId,
          },
        });
      }
      await deleteProductMutation.mutateAsync({
        projectId,
        productId,
      });
    },
    [projectId, deleteProductMutation],
  );

  return { deleteProduct, isLoading: deleteProductMutation.isPending };
};
